"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ProductSwitcher = /*#__PURE__*/function () {
  function ProductSwitcher(component) {
    (0, _classCallCheck2["default"])(this, ProductSwitcher);
    this.dom = {
      $component: component,
      $radios: Array.from(component.querySelectorAll('.js-product-switcher-variant')),
      $productSwitcher: document.querySelector('.js-productForm-productSwitcher'),
      $productFormValue: Array.from(document.querySelectorAll('.js-productForm-value')),
      $productDetails: document.querySelector('.js-productDetails'),
      $submitButton: document.querySelector('.js-productForm-submit'),
      $notifyForm: document.querySelector('.ProductNotifyme'),
      $selectedSize: document.querySelector('.js-product-notifyme-size'),
      $lowInStockNotification: document.querySelector('.js-product-switcher-lis')
    }, this.state = {
      path: window.location.pathname,
      unavailableClass: 'js-product-switcher-variant--unavailable',
      productFormClassActive: 'ProductDetails--active'
    };
    this.mount();
  }

  (0, _createClass2["default"])(ProductSwitcher, [{
    key: "mount",
    value: function mount() {
      var self = this;
      var dom = this.dom;
      console.log('ProductSwitcher : mount', this);

      if (dom.$radios.length) {
        dom.$radios.forEach(function ($radio) {
          return $radio.addEventListener('change', function (event) {
            return self["switch"](event);
          });
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var self = this;
      var dom = this.dom;
      console.log('ProductSwitcher : unmount', this);
      dom.$radios.forEach(function ($radio) {
        return $radio.removeEventListener('change', function (event) {
          return self["switch"](event);
        });
      });
    }
  }, {
    key: "switch",
    value: function _switch(event) {
      console.log('ProductSwitcher : switch', this);
      var self = this;
      var dom = this.dom,
          state = this.state;

      if (dom.$lowInStockNotification) {
        if (parseInt(event.target.dataset.stock) > 0 && parseInt(event.target.dataset.stock) <= parseInt(dom.$lowInStockNotification.dataset.listhreshold)) {
          dom.$lowInStockNotification.classList.add('active');
          dom.$lowInStockNotification.querySelector('span').innerHTML = event.target.dataset.stock;
        } else {
          dom.$lowInStockNotification.classList.remove('active');
        }
      }

      if (event.target.classList.contains(state.unavailableClass)) {
        if (dom.$selectedSize) {
          dom.$selectedSize.innerHTML = event.target.dataset.title;
        }

        dom.$productDetails.classList.remove(state.productFormClassActive);
      } else {
        dom.$productDetails.classList.add(state.productFormClassActive);
      }

      if (dom.$productSwitcher) {
        dom.$productSwitcher.classList.remove('ProductDetails__switcher--error');
      }

      if (dom.$notifyForm) {
        dom.$notifyForm.classList.remove('ProductNotifyme--error');
      }

      if (dom.$productFormValue) {
        dom.$productFormValue.forEach(function ($el) {
          $el.value = event.target.value;
        });
      }

      if (dom.$submitButton) {
        dom.$submitButton.value = dom.$submitButton.dataset.value;
      }
    }
  }]);
  return ProductSwitcher;
}();

exports["default"] = ProductSwitcher;